// widgets/location-popover/ui/LocationPopoverContent.tsx

import Points from '@/_components/Points';
import type { IPoint } from '@/_store/common/types';
import type { IOrderType, ISavedBranch } from '@/_store/types';
import { PopoverBody, PopoverContent } from '@/components/ui/popover';
import React from 'react';
import { LocationPopoverMode } from '../lib/location-popover-state';
import AskAddress from './ask-address';
import SavedAddressPopover from './saved-address-popover';

type Props = {
  open: boolean;
  mode: LocationPopoverMode;

  geolocationAccepted: boolean;

  orderType: IOrderType | null;
  activePoint: IPoint | null;
  branch: ISavedBranch | null;

  onClose: () => void;
  onOpenSelector: () => void;
  onConfirmSaved: () => void;
};

const LocationPopoverContent: React.FC<Props> = ({
  open,
  mode,
  geolocationAccepted,
  orderType,
  activePoint,
  branch,
  onClose,
  onOpenSelector,
  onConfirmSaved,
}) => {
  return (
    <PopoverContent
      maxW='480px'
      portalled={false}
      w={!geolocationAccepted ? 'full' : '480px'}
      bg='background.card'
    >
      <PopoverBody py={4} px={3} rounded={16}>
        {mode === 'points' && <Points isOpen={open} onClose={onClose} />}

        {mode === 'ask' && (
          <AskAddress
            orderType={orderType}
            onClose={onClose}
            onOpenSelector={onOpenSelector}
          />
        )}

        {mode === 'saved' && (
          <SavedAddressPopover
            orderType={orderType}
            branch={branch}
            address={activePoint?.address}
            onClose={onClose}
            onOpenSelector={onOpenSelector}
            onConfirmSaved={onConfirmSaved}
          />
        )}
      </PopoverBody>
    </PopoverContent>
  );
};

export default LocationPopoverContent;
